/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum EventKind {
    BADGE_ZONE_VIOLATION = 'badgeZoneViolation',
    SHOCK = 'shock',
    VEHICLE_ZONE_VIOLATION = 'vehicleZoneViolation'
}


export function instanceOfEventKind(value: any): boolean {
    for (const key in EventKind) {
        if (Object.prototype.hasOwnProperty.call(EventKind, key)) {
            if (EventKind[key as keyof typeof EventKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EventKindFromJSON(json: any): EventKind {
    return EventKindFromJSONTyped(json, false);
}

export function EventKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventKind {
    return json as EventKind;
}

export function EventKindToJSON(value?: EventKind | null): any {
    return value as any;
}

export function EventKindToJSONTyped(value: any, ignoreDiscriminator: boolean): EventKind {
    return value as EventKind;
}

